/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ProductListItem_user$ref = any;
export type ProductListItem_user = {
    readonly id: string;
    readonly role: string | null;
    readonly conciergeCustomerAccountId: string | null;
    readonly conciergeUser: ({
        readonly id: string;
        readonly userId: string | null;
        readonly permissions: ({
            readonly id: string;
            readonly oneCommerce: ({
                readonly id: string;
                readonly preferredCustomer: ({
                    readonly access: boolean | null;
                }) | null;
            }) | null;
        }) | null;
        readonly subscriptions: ({
            readonly wineClub: ({
                readonly enrollmentStatus: string | null;
                readonly subscriptionStatus: string | null;
            }) | null;
        }) | null;
    }) | null;
    readonly cartV2: ({
        readonly id: string;
        readonly cartId: string | null;
        readonly discountQualifiedCartTotal: number | null;
        readonly entries: ({
            readonly edges: ReadonlyArray<({
                readonly node: ({
                    readonly id: string;
                    readonly sku: string | null;
                    readonly productId: string | null;
                    readonly quantity: number | null;
                    readonly productName: string | null;
                    readonly productURLslug: string | null;
                    readonly productImageUrl: string | null;
                    readonly wineBottleQuantity: number | null;
                    readonly isWinePack: boolean | null;
                    readonly priceOriginal: number | null;
                    readonly priceSale: number | null;
                    readonly priceDiscount: number | null;
                    readonly discountEligible: boolean | null;
                    readonly priceDiscountPercent: number | null;
                    readonly hasQualifyingDiscount: boolean | null;
                }) | null;
            }) | null> | null;
        }) | null;
    }) | null;
    readonly subscriptions: ({
        readonly wineClub: ({
            readonly enrollmentStatus: string | null;
            readonly subscriptionStatus: string | null;
        }) | null;
    }) | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly preferredCustomer: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly " $refType": ProductListItem_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "access",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "subscriptions",
        "storageKey": null,
        "args": null,
        "concreteType": "Subscriptions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "wineClub",
                "storageKey": null,
                "args": null,
                "concreteType": "WineClubType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enrollmentStatus",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subscriptionStatus",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any);
    return {
        "kind": "Fragment",
        "name": "ProductListItem_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "conciergeCustomerAccountId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conciergeUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userId",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/),
                    (v2 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "cartV2",
                "storageKey": null,
                "args": null,
                "concreteType": "CartV2",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cartId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountQualifiedCartTotal",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "entries",
                        "storageKey": "entries(first:1000)",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000,
                                "type": "Int"
                            }
                        ],
                        "concreteType": "CartEntryV3Connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CartEntryV3Edge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "CartEntryV3",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "wineBottleQuantity",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productId",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "quantity",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productName",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productURLslug",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productImageUrl",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "sku",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isWinePack",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceOriginal",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceSale",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceDiscount",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "discountEligible",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceDiscountPercent",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "hasQualifyingDiscount",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            (v2 /*: any*/),
            (v1 /*: any*/)
        ]
    } as any;
})();
(node as any).hash = 'b377023a22a71f4f484b2a468fb1697a';
export default node;
